import { useState, useEffect } from "react";
import { Toaster } from "sonner";
import { Routes, Route } from "react-router-dom";

import { useAuth } from "./hooks/useAuth";
import { useSubdomain } from "./hooks/useSubdomain";
import LoginPage from "./views/LoginPage";
import AppRouter from "./AppRouter";
import SetupWizard from "./views/setup/SetupWizard";
import SchoolWebsite from './views/schoolwebsite/SchoolWebsite';


/**
 * Entry point — only responsible for the auth gate.
 * All routing and data logic lives in AppRouter.
 */
export default function AppIndex() {
  const [lang, setLang] = useState("en");
  const { user, logout, sendOTP, verifyOTP, requiresSetup } = useAuth();
  const subdomain = useSubdomain();
  
  // Redirect to setup wizard if required (only for admin users)
  useEffect(() => {
    const isAdmin = user?.role === 'admin' || user?.role === 'superadmin';
    if (user && isAdmin && requiresSetup && window.location.pathname !== '/setup-wizard') {
      window.location.href = '/setup-wizard';
    }
  }, [user, requiresSetup]);
  
  // Check if on setup wizard route
  const isSetupWizard = window.location.pathname === '/setup-wizard';
  
  return (
    <>
      <Toaster position="top-right" richColors closeButton />
      <Routes>
        <Route path="/s/:slug" element={<SchoolWebsite />} />
        <Route
          path="*"
          element={
            user ? (
              isSetupWizard ? (
                <SetupWizard />
              ) : (
                <AppRouter onLogout={logout} />
              )
            ) : (
              <LoginPage
                onSendOTP={sendOTP}
                onVerifyOTP={verifyOTP}
                lang={lang}
                setLang={setLang}
                subdomain={subdomain}
              />
            )
          }
        />
      </Routes>
    </>
  );
}